module.exports = __webpack_public_path__ + "static/media/dontcopy3.6b958d34.gif";